import React, { useState } from 'react';
import { ExportCsvButton } from './ExportCsvButton';
import { ExportCsvDialog } from './ExportCsvDialog';
import type { ExportCsvContextProps } from './types';

// -- type definitions --

export type ExportCsvOverlayProps = ExportCsvContextProps;

// -- main component --

/**
 * CSV export button and dialog stacked on top of the plot area.
 */
export const ExportCsvOverlay: React.FC<ExportCsvOverlayProps> = ({
  curvePrefs,
  timeRanges,
  onExportCsv,
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  return (
    <>
      <ExportCsvButton onClick={handleOpenDialog} />
      <ExportCsvDialog
        open={isDialogOpen}
        onClose={handleCloseDialog}
        curvePrefs={curvePrefs}
        timeRanges={timeRanges}
        onExportCsv={onExportCsv}
      />
    </>
  );
};
